import { useMediaQuery as useMuiMediaQuery, useTheme } from '@mui/material'
import { useMemo } from 'react'

interface MediaQuery {
  /** smサイズ(600px以上)であるか */
  isSm: boolean
  /** Whether the viewport is md (900px) or wider */
  isMd: boolean
}

export function useMediaQuery(): MediaQuery {
  const theme = useTheme()
  const isSm = useMuiMediaQuery(theme.breakpoints.up('sm'))
  const isMd = useMuiMediaQuery(theme.breakpoints.up('md'))

  return useMemo(
    () => ({
      isSm,
      isMd,
    }),
    [isSm, isMd],
  )
}
